import React, { useState, useEffect } from 'react';
import TableHeader from '../../Shared/TableHeader';
import CommonTable from '../../Shared/Tables';
import SelectDropdown from '../../Shared/SelectDropdown';
import { channelListAtom } from '../../../Services/_states';
import { useRecoilValue } from 'recoil';
import { InterveneActions } from '../../../Services/_actions/Intervene/intervene.actions';

const ChatList = () => {
  const actions = InterveneActions();
  const [filtersObj, setFiltersObj] = useState({ bot_number: '', flowId: '' });
  const channelList = useRecoilValue(channelListAtom);
  const [flowList, setFlowList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [chatSummaryList, setChatSummaryList] = useState([]);
  const [columns, setColumns] = useState([
    { dataField: 'default', text: 'No Data Available' }
  ]);

  const getFlowListByBotNumber = async (botNumber) => {
    try {
      let res = await actions.getFlowListByBotNumber(botNumber);
      if (res) setFlowList(res);
    } catch (error) {
      console.error('Error fetching flow list:', error);
    }
  };

  const getUserChatSummary = async (filtersObj) => {
    try {
      setIsLoading(true);
      let res = await actions.getUserChatSummary(filtersObj);
      if (res) {
        const data = res.data || [];
        setChatSummaryList(data);
        generateColumns(data);
      }
    } catch (error) {
      console.error('Error fetching chat summary:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const generateColumns = (data) => {
    if (data && data.length > 0) {
      const keys = Array.from(
        new Set(data.flatMap((item) => Object.keys(item).filter((key) => key !== 'message_ids')))
      );

      // Extract keys from `hiring_details` if present
      const hiringKeys = Array.from(
        new Set(
          data.flatMap((item) =>
            item.hiring_details ? Object.keys(item.hiring_details) : []
          )
        )
      );

      // Generate columns for top-level keys
      let dynamicColumns = keys.map((key, index) => ({
        dataField: key,
        text: key.replace(/_/g, ' ').toUpperCase(),
        headerAlign: 'center',
        align: 'center',
        style: { fontSize: '12px' },
        key: `column-${index}`,
        formatter: (cell) =>
          typeof cell === 'object' && cell !== null
            ? JSON.stringify(cell)
            : cell !== null && cell !== undefined
            ? cell
            : 'N/A',
      }));

      // Add individual columns for each key in `hiring_details` if it has valid keys
      if (hiringKeys.length > 0) {
        dynamicColumns = dynamicColumns.concat(
          hiringKeys.map((key, index) => ({
            dataField: `hiring_details.${key}`,
            text: key.replace(/_/g, ' ').toUpperCase(),
            headerAlign: 'center',
            align: 'center',
            style: { fontSize: '12px' },
            key: `hiring-column-${index}`,
            formatter: (_, row) =>
              row.hiring_details && row.hiring_details[key]
                ? row.hiring_details[key]
                : 'N/A',
          }))
        );
      }

      setColumns(dynamicColumns);
    } else {
      setColumns([{ dataField: 'default', text: 'No Data Available', key: 'default-column' }]);
    }
  };

  const handleSelectBot = (e) => {
    setFiltersObj({ ...filtersObj, bot_number: e?.channel_number });
    if (e?.channel_number) getFlowListByBotNumber(e?.channel_number);
  };

  const handleSelectFlow = (e) => {
    setFiltersObj({ ...filtersObj, flowId: e?.flow_id });
    if (e?.flow_id) getUserChatSummary({ ...filtersObj, flowId: e?.flow_id });
  };

  return (
    <>
      <TableHeader headerValue="Chat Summary" />
      <div className="d-flex mb-3">
        <div className="me-3">
          <SelectDropdown
            optionsData={channelList}
            selectedValue={channelList?.find(
              (item) => item?.channel_number === filtersObj?.bot_number
            )}
            placeholder="Select Channel"
            label="Select Channel"
            id="select-bot"
            OptionLabel="channel_number"
            OptionValue="channel_number"
            handleSelect={handleSelectBot}
            isClearable
            addOptionLabel={['app_name']}
          />
        </div>
        <div className="me-3">
          <SelectDropdown
            optionsData={flowList || []}
            selectedValue={flowList?.find((item) => item?.flow_id === filtersObj?.flowId)}
            placeholder="Select Flow"
            label="Select Flow"
            id="select-flow"
            OptionLabel="flow_name"
            OptionValue="flow_id"
            handleSelect={handleSelectFlow}
            isClearable
          />
        </div>
      </div>
      <CommonTable
        id="C_ID"
        columnsData={columns}
        rowData={chatSummaryList.map((item, index) => ({
          ...item,
          id: item.id || index,
        }))}
        keyField="id"
        emptyMessage="No Summary Found"
        isLoading={isLoading}
      />
    </>
  );
};

export default ChatList;
